/* eslint-disable import/no-duplicates */
import ChevronDown from '@atom-web/icons-24/ChevronDown'
import ChevronTop from '@atom-web/icons-24/ChevronTop'
import { Box, Column, Row, Text } from '@atom-web/micros'
import { chunk } from 'lodash'
import { useEffect, useState } from 'react'

const AmenitiesSection = ({
	data,
	isMobile,
	titleProps,
	wrapperProps,
	showTitle = true,
}) => {
	const [showAll, setShowAll] = useState(false)
	const [chunkedData, setChunkedData] = useState([])

	useEffect(() => {
		const diviser = isMobile ? 2 : 3
		const size = Math.ceil(data?.length / diviser)
		setChunkedData(chunk(data, size))
	}, [data, isMobile])
	return (
		<Column
			css={{
				width: '100%',
				backgroundColor: '#fff',
				'@smMax': {
					padding: '0 16px 16px 16px',
				},
				...wrapperProps,
			}}
		>
			{showTitle && (
				<Text
					css={{
						fontSize: '$5',
						fontWeight: '$bold',
						lineHeight: '25px',
						paddingBottom: '10px',
						...titleProps,
					}}
				>
					Amenities
				</Text>
			)}
			{!isMobile ? (
				<Row
					css={{
						width: '90%',
						justifyContent: 'space-between',
						gap: '$2',
					}}
				>
					<Column
						css={{
							width: '33%',
							paddingTop: '10px',
							paddingBottom: '10px',
							alignSelf: 'baseline',
						}}
					>
						{chunkedData[0]
							?.filter((val, inx) =>
								chunkedData[0].length > 4 && !showAll ? inx < 4 : val,
							)
							.map(({ icon, name }, inx) => (
								<Row
									css={{
										gap: 8,
										paddingTop: '10px',
										paddingBottom: '10px',
									}}
									key={inx}
								>
									{icon}
									<Text>{name}</Text>
								</Row>
							))}
					</Column>
					<Column
						css={{
							width: '33%',
							paddingTop: '10px',
							paddingBottom: '10px',
							alignSelf: 'baseline',
						}}
					>
						{' '}
						{chunkedData[1]
							?.filter((val, inx) =>
								chunkedData[1].length > 4 && !showAll ? inx < 4 : val,
							)
							.map(({ icon, name }, inx) => (
								<Row
									css={{
										gap: 8,
										paddingTop: '10px',
										paddingBottom: '10px',
									}}
									key={inx}
								>
									{' '}
									{icon}
									<Text>{name}</Text>
								</Row>
							))}
					</Column>
					<Column
						css={{
							width: '34%',
							paddingTop: '10px',
							paddingBottom: '10px',
							alignSelf: 'baseline',
						}}
					>
						{' '}
						{chunkedData[2]
							?.filter((val, inx) =>
								chunkedData[2].length > 4 && !showAll ? inx < 4 : val,
							)
							.map(({ icon, name }, inx) => (
								<Row
									css={{
										gap: 8,
										paddingTop: '10px',
										paddingBottom: '10px',
									}}
									key={inx}
								>
									{' '}
									{icon}
									<Text>{name}</Text>
								</Row>
							))}
					</Column>
				</Row>
			) : (
				<Row
					css={{
						justifyContent: 'space-between',
						width: '100%',
					}}
				>
					<Column
						css={{
							width: '50%',
							paddingTop: '10px',
							paddingBottom: '10px',
							alignSelf: 'baseline',
						}}
					>
						{chunkedData[0]
							?.filter((val, inx) =>
								chunkedData[0].length > 4 && !showAll ? inx < 4 : val,
							)
							.map(({ icon, name }, inx) => (
								<Row
									key={inx}
									css={{
										gap: 8,
										alignItems: 'flex-start',
										paddingTop: '10px',
										paddingBottom: '10px',
									}}
								>
									{icon}
									<Column
										css={{
											flex: 1,
											flexWrap: 'wrap',
										}}
									>
										<Text>{name}</Text>
									</Column>
								</Row>
							))}
					</Column>
					<Column
						css={{
							width: '50%',
							paddingTop: '10px',
							paddingBottom: '10px',
							alignSelf: 'baseline',
						}}
					>
						{chunkedData[1]
							?.filter((val, inx) =>
								chunkedData[1].length > 4 && !showAll ? inx < 4 : val,
							)
							.map(({ icon, name }, inx) => (
								<Row
									key={inx}
									css={{
										gap: 9,
										alignItems: 'flex-start',
										paddingTop: '10px',
										paddingBottom: '10px',
									}}
								>
									{icon}
									<Column
										css={{
											flex: 1,
											flexWrap: 'wrap',
										}}
									>
										<Text>{name}</Text>
									</Column>
								</Row>
							))}
					</Column>
				</Row>
			)}

			{chunkedData?.[0]?.length > 4 && !showAll ? (
				<Box onClick={() => setShowAll(true)}>
					<Row
						css={{
							gap: 8,
						}}
					>
						<Text fontSize={16} fontWeight={600} lineHeight={20}>
							View all
						</Text>
						<ChevronDown />
					</Row>
				</Box>
			) : null}
			{showAll ? (
				<Box
					css={{
						paddingTop: '10px',
					}}
					onClick={() => setShowAll(false)}
				>
					<Row
						css={{
							gap: 8,
						}}
					>
						{' '}
						<Text
							css={{
								fontSize: '$4',
								fontWeight: '$bold',
								lineHeight: '20px',
							}}
						>
							View less
						</Text>
						<ChevronTop />
					</Row>
				</Box>
			) : null}
		</Column>
	)
}

export default AmenitiesSection
